/**
 * IssuanceGateController — EPIC-055 / 55.11.
 *
 * Bannière de suspension d'émission de factures, partageable avec le wizard
 * de facturation (55.8). Consomme GET /billing/issuance-status et
 * affiche une bannière `nm-banner--critical` quand `canIssue === false`.
 *
 * Usage : `<div data-controller="issuance-gate"></div>` sur n'importe quelle
 * page applicative. Le controller construit le DOM lui-même (pas de template
 * HTML requis dans la page hôte).
 *
 * Convention CLAUDE.md respectée :
 *  - 0 HTML inline en JS (createElement + textContent + classList).
 *  - Vocabulaire UI : « émission », « prélèvement automatique » — pas de
 *    « Qonto », « PDP », « NotaFacto », « Sweego », « OCR ».
 *  - Bannière non dismissible (le statut redevient utilisable une fois la
 *    cause levée ; le `refresh()` re-rend l'état).
 */

import BaseController from "./base_controller.js";
import { api } from "/js/services/api.js";

const REASON_MESSAGE = {
  past_due: "Régularisez votre situation en configurant votre prélèvement automatique.",
  no_mandate: "Configurez votre prélèvement automatique pour reprendre l'émission de factures.",
};

const REASON_CTA = {
  past_due: { label: "Configurer le prélèvement automatique", href: "abonnement.html#mandat" },
  no_mandate: { label: "Configurer le prélèvement automatique", href: "abonnement.html#mandat" },
};

export default class IssuanceGateController extends BaseController {
  async connect() {
    try {
      const state = await api.getIssuanceStatus();
      this.render(state);
    } catch (_error) {
      // Silencieux : un échec de la lecture du statut ne doit pas casser la
      // page hôte. La bannière reste masquée par défaut.
    }
  }

  async refresh() {
    this.element.replaceChildren();
    await this.connect();
  }

  render(state) {
    this.element.replaceChildren();

    if (state === null || state.canIssue !== false) {
      return;
    }

    const reason = state.suspensionReason || "no_mandate";

    const banner = document.createElement("div");
    banner.className = "nm-banner nm-banner--critical";
    banner.setAttribute("role", "alert");

    const title = document.createElement("strong");
    title.textContent = "L'émission de factures est temporairement suspendue.";
    banner.appendChild(title);

    const description = document.createElement("p");
    description.textContent = REASON_MESSAGE[reason] || REASON_MESSAGE.no_mandate;
    description.style.margin = "8px 0 0";
    banner.appendChild(description);

    const cta = REASON_CTA[reason] || REASON_CTA.no_mandate;
    const actions = document.createElement("div");
    actions.className = "nm-banner__actions";
    const link = document.createElement("a");
    link.className = "nm-btn nm-btn--solid";
    link.href = cta.href;
    link.textContent = cta.label;
    actions.appendChild(link);
    banner.appendChild(actions);

    this.element.appendChild(banner);
  }
}
